/*
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2023-11-11 10:48:10
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-20 10:42:58
 * @FilePath: \vnlin\oms\src\api\endTripManage\endTripBill.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 尾程提单增删改查
export const operEndTripBill = (params) => {
  let method = params.method;
  delete params.method;
  return axios.request({
    url: `/extract/extract_end${params.id ? "/" + params.id : ""}`,
    [method == "get" ? "params" : "data"]: params,
    method: method,
  });
};

// 尾程提单新增
export const addEndTripBill = (data) => {
  return axios.request({
    url: `/extract/extract_end`,
    data,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
  });
};

// 移入移出
export const moveEndTripBill = (data) => {
  return axios.request({
    url: `/extract/extract_end/handleBag`,
    data,
    method: "post",
  });
  1;
};

// 尾程提单导出
export const exportEndTripBill = (id) => {
  return axios.request({
    url: `/extract/extract_end/exportManifest/${id}`,
    method: "post",
  });
};

// 尾程提单导出manifest
export const exportPreAlert = (id) => {
  return axios.request({
    url: `/extract/extract_end/exportPreAlert/${id}`,
    method: "post",
  });
};

// 获取未到仓订单
export const getEndTripBill = (params) => {
  return axios.request({
    url: `/extract/extract_end/getNotWarehouse`,
    params,
    method: "get",
  });
};

// 添加备注指令
export const addRemark = (data) => {
  return axios.request({
    url: `/extract/extract_end/extractEndRemarkInstruction`,
    data,
    method: "post",
  });
};

export const createBill = (params) => {
  return axios.request({
    url: `/extract/extract_end/createBill`,
    params,
    method: "get",
  });
};

export const order = (params) => {
  return axios.request({
    url: `/extract/extract_end/orderlist`,
    method: "get",
    params
  });
};
